import React from "react";
import ApInfoInlet from "./ApInfoInlet";
import ApActionButton from "./ApActionButton";

class ApFooter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="ApFooter">
        <ApActionButton description="Freigeben" onClick={() => {}} color="good">
          <i className="fas fa-check" />
        </ApActionButton>
        <ApActionButton description="Ablehnen" onClick={() => {}} color="bad">
          <i className="fas fa-times" />
        </ApActionButton>

        <ApInfoInlet
          label={this.props.label}
          onButtonClick={this.props.onButtonClick}
          small
        />
        <i
          data-tip="Drehen"
          className="ApQuestionBtn fas fa-sync-alt"
          onClick={() => this.props.onButtonClick("rotate")}
        />
      </div>
    );
  }
}

export default ApFooter;



// WEBPACK FOOTER //
// ./src/components/approval/ApFooter.js